package com.tixforgigs.common.ui.pages.error


import com.tixforgigs.common.core.enums.View
import com.tixforgigs.common.core.extensions.RoutingUtil.AppScope
import com.tixforgigs.common.core.extensions.RoutingUtil.routing
import com.tixforgigs.common.core.extensions.navigateTo
import com.tixforgigs.common.core.interfaces.StorefrontPage
import com.tixforgigs.common.core.util.TrackerUtil.pageView
import com.tixforgigs.common.ui.components.mandarin.mandarinTitle
import com.tixforgigs.common.ui.components.root.defaultTemplate
import com.tixforgigs.common.ui.components.structure.containerPanel
import com.tixforgigs.tarami.AraiMessage.textError
import com.tixforgigs.tarami.GlobalMessage.titleHome
import io.kvision.event.clickFlow
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.button.filledButton
import io.kvision.panel.SimplePanel
import io.kvision.panel.simplePanel
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.launch
import kotlin.time.ExperimentalTime


@OptIn(ExperimentalMaterialApi::class, ExperimentalTime::class)
class ErrorView : SimplePanel(className = "xm-page xm-page-error"), StorefrontPage {

  override val VIEW: View get() = View.ERROR

  init {

    AppScope.launch {
      pageView()
    }

    defaultTemplate {
      containerPanel {
        mandarinTitle(textError())
        simplePanel(className = "xm-flex-container") {
          simplePanel(className = "xm-flex-column xm-flex-center") {
            filledButton(text = titleHome()).clickFlow.onEach {
              routing.navigateTo(View.RELATIVE_BASE_PATH_ROOT)
            }.launchIn(MainScope())
          }
        }
      }
    }
  }
}
